"use strict";

exports.__esModule = true;
var StoreType;

(function (StoreType) {
  StoreType["CryptoApi"] = "cryptoApi";
  StoreType["Pkcs11"] = "pkcs11";
  StoreType["Requisite"] = "requisite";
  StoreType["CACabinet"] = "CACabinet";
})(StoreType = exports.StoreType || (exports.StoreType = {}));

var StoreName;

(function (StoreName) {
  StoreName["My"] = "My";
  StoreName["Root"] = "Root";
  StoreName["CA"] = "CA";
  StoreName["AddressBook"] = "AddressBook";
})(StoreName = exports.StoreName || (exports.StoreName = {}));

var StoreLocation;

(function (StoreLocation) {
  StoreLocation["User"] = "user";
  StoreLocation["Machine"] = "machine";
})(StoreLocation = exports.StoreLocation || (exports.StoreLocation = {}));

var CryptoProviderType;

(function (CryptoProviderType) {
  CryptoProviderType["CryptoApi"] = "cryptoApi";
  CryptoProviderType["Pkcs11"] = "pkcs11";
})(CryptoProviderType = exports.CryptoProviderType || (exports.CryptoProviderType = {}));